import React from 'react'
import {message, Popconfirm} from "antd";
import {deleteCustomerToList} from "../../../../services/api/apListCustomers";

const DeleteCustomer = (props) => {
    const {arrSelected, fetchDetailListCustomers, onClearChecked, listCusID} = props

    const deleteCustomer = async () => {
        try {
            const payload = {
                customerListId: listCusID,
                listOfCustId: arrSelected.toString()
            }
            const response = await deleteCustomerToList(payload)
            const {success} = response
            if (success !== '1') {
                onClearChecked()
                return message.error("Xóa khách hàng không thành công.")
            }
            fetchDetailListCustomers()
            onClearChecked()
            message.success("Xóa khách hàng thành công.")
        } catch (e) {
            message.error(e.message)
        }
        onClearChecked()
    }

    return <>
        <Popconfirm placement="left" title="Bạn chắc chắn muốn xóa khách hàng?" onConfirm={deleteCustomer} okText="Yes"
                    cancelText="No">
            <button className="btn btn-danger mr-3">Xóa khách hàng</button>
        </Popconfirm>
    </>
}

export default DeleteCustomer
